import type MailboxInfo from 'owa-client-types/lib/MailboxInfo';

// Do NOT use this function unless importing serviceRequestCapability from owa-capabilities-definitions
// in your package leads to a circular dependency (e.g. your code is in owa-service, owa-ows-gateway)
export function isServiceRequestSupportedForMailbox(mailboxInfo?: MailboxInfo): boolean {
    // PST file accounts don't support service requests - PST files are local
    // and don't have an associated user/mailbox entity in the service
    return mailboxInfo?.type !== 'PstFile';
}
